module.exports = __webpack_public_path__ + "static/media/cal-4.cf507a1f.jpg";